import { Injectable } from '@angular/core'
import { ActionCreator } from '@ngrx/store'
import { PayloadedAction } from '../types'
import { dispatchErrorAction } from '../utils'

@Injectable({
  providedIn: 'root',
})
export class ErrorReportingService {

  notifyErrorObservable(
    error: Error,
    actions: Array<PayloadedAction> | ActionCreator,
    stateValues: any = {} // TODO this was only used in the request to send the Dynatrace errors, remove this and refactor all methods using this.
  ): Array<PayloadedAction> {
    console.error(`ErrorReportingService: ${error}`)
    return Array.isArray(actions) 
      ? actions 
      : [dispatchErrorAction(actions as ActionCreator, error)]
  }
}
